

















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { AssetClass1, AssetClassesApi } from 'performo-api';
import { mapGetters } from 'vuex';
import { handleApiError } from '@/ApiHelpers';

@Component({
  computed: mapGetters({
    api: 'assetClassesApi'
  })
})
export default class AssetClass1Picker extends Vue {
  @Prop({ required: false, default: 'asset-class-1-picker' })
  private id?: string;

  @Prop({ required: false, default: false, type: Boolean })
  private required?: boolean;

  @Prop({ required: false, default: false, type: Boolean })
  private hideAll?: boolean;

  @Prop({ required: false, default: false, type: Boolean })
  private hideLabel?: boolean;

  @Prop({ required: true })
  private value!: string;

  @Prop({ required: false, default: 'System' })
  private labelOverride?: string;

  get getValue() {
    return this.value;
  }

  get sortedClasses() {
    return this.classes.sort((a, b) => {
      if (!a.assetClass1Name || !b.assetClass1Name) return 0;
      var nameA = a.assetClass1Name.toUpperCase(); // ignore upper and lowercase
      var nameB = b.assetClass1Name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    });
  }

  private api!: AssetClassesApi;
  private classes: AssetClass1[] = [];
  private loadingClasses = false;

  private async loadClasses() {
    try {
      this.classes = await this.api.assetClass1Query({ assetClass1Name: '*' });
      return this.classes;
    } catch (error) {
      return handleApiError(error);
    }
  }

  private async mounted() {
    this.loadingClasses = true;
    await this.loadClasses();
    this.loadingClasses = false;
  }
}
